module.exports = __webpack_public_path__ + "img/Particules_footer.dace9ca3.svg";